<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header" @click.stop>
          <slot name="header">default header</slot>
          <div class="font-large icon__bg-circle close-cross" @click.stop="$emit('close')">
            <span class="icon-cross2 pointer"></span>
          </div>
        </div>
        <div class="modal-body">
          <slot name="body">
            default body
          </slot>
        </div>
        <div class="modal-footer" v-if="isShowFooter">
          <button class="bttn create-btn right marg-10" @click="$emit('submit')">
            {{ submitTxt }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    submitTxt: {
      type: String,
      default: 'OK'
    },
    isShowFooter: {
      default: true,
      type: Boolean
    }
  }
}
</script>
<style scoped>
@import "../../assets/css/variables.css";

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .15s ease;
}

.modal-wrapper {
  position: relative;
}

@media handheld, only screen and (max-width: 767px) {
  .modal-header {
    font-size: 0.7em;
  }

  .modal-wrapper {
    width: 100%;
    height: 100%;
  }

  .close-cross {
    top: 12px;
    left: 12px;
  }
}

.modal-container {
  transition: all .3s ease;
  height: 100%;
  width: 100%;
  background: #f6f9fc;
  color: #4e5665;
  box-shadow: -1px 1px 5px 0px rgba(50, 50, 50, 0.2);
  position: relative;
  animation-name: fadeUp;
  animation-duration: 0.25s;
}

@media handheld, only screen and (min-width: 767px) {
  .modal-container {
    height: 580px;
    width: 800px;
    border-radius: 3px;
  }

  .close-cross {
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
  }
}

.modal-header {
  background: #fff;
  padding: 1rem;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  color: #3d4340;
  border-bottom: 1px solid #d8d8d8;
  text-align: center;
  position: relative;
}

.close-cross {
  position: absolute;
}

.modal-body {
  padding: 10px 20px;
  height: calc(100% - 100px);
  overflow-y: auto;
}

.modal-footer {
  background: #f6f9fc;
  overflow: hidden;
  border-top: 1px solid #d8d8d8;
  margin-bottom: 0;
  border-radius: 0 0 4px 4px;
  text-align: center;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(0.8);
}

.create-btn {
  color: white;
  box-shadow: 0 2px 2px rgba(0, 0, 0, .1);
  background-color: #468AD7;
  border: 1px solid #4e80b7 !important;
  transition: background-color 0.3s, transform 0.3s;
  transform: scale(1);
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.create-btn:hover {
  background-color: #66a1e4;
}

.create-btn:active {
  transform: scale(0.98)
}
</style>



// WEBPACK FOOTER //
// AppModal.vue?24e19543